module.exports = __webpack_public_path__ + "img/HRV.dcc5dd47.png";